import { CURRENT, FAIL, GETALLUSERS, GETONEUSER, LOGIN, LOGOUT, REGISTER } from "../ActionTypes/AuthTypes"
import axios from 'axios'
import { handleerror } from "./ErrorsActions"

export const register = (cordUser, navigate) => async (dispatch) => {
  try {
    const res = await axios.post("/api/auth/SignUp", cordUser);

    dispatch({
      type: REGISTER,
      payload: res.data,
    });

    navigate("/AllUser");
  } catch (error) {
    console.log("Erreur Register :", error.response?.data || error.message);

    if (error.response?.data?.errors) {
      error.response.data.errors.forEach((el) =>
        dispatch(handleerror(el.msg))
      );
    } else {
      dispatch(handleerror("Une erreur est survenue lors de l'inscription."));
    }
  }
};

export const login = (cordUser, navigate) => async (dispatch) => {
  try {
    const res = await axios.post('/api/auth/SignIn', cordUser);

    console.log('🔍 RÉPONSE LOGIN:', res.data);
    console.log('🎯 RÔLE UTILISATEUR:', res.data.user?.role);
    console.log('📍 LOCALISATION:', res.data.user?.localisation);

    // Stocker dans localStorage
    localStorage.setItem('token', res.data.token);
    if (res.data.user) {
      localStorage.setItem('user', JSON.stringify(res.data.user));

      // 🔥 CORRECTION : Stocker la localisation pour le filtrage
      if (res.data.user.localisation && res.data.user.localisation.name) {
        localStorage.setItem('userLocation', res.data.user.localisation.name);
        console.log('✅ userLocation enregistré:', res.data.user.localisation.name);
      } else {
        console.warn('⚠️ Pas de localisation pour cet utilisateur');
        localStorage.removeItem('userLocation'); // Nettoyer si pas de localisation
      }
    }

    // 🔥 CORRECTION : Structure sécurisée pour localisationName
    const loginPayload = {
      user: res.data.user || res.data.found,
      token: res.data.token,
      msg: res.data.msg,
      localisationName: (res.data.user?.localisation?.name || res.data.found?.localisation?.name)
    };

    dispatch({
      type: LOGIN,
      payload: loginPayload
    });

    // Redirection basée sur le rôle
    const userRole = res.data.user?.role || res.data.found?.role;

    console.log('🔄 Redirection pour rôle:', userRole);

    switch (userRole) {
      case 'admin':
        navigate('/BrandStatsHub');
        break;
      case 'useradmin':
        navigate('/BrandStatsHub');
        break;
      case 'usertwinpark':
        navigate('/Valises');
        break;
      case 'userbagngo':
        navigate('/Valises');
        break;
      case 'userespace':
        navigate('/Valises');
        break;
      case 'userspintoss':
        navigate('/AddRapportsSpintoss');
        break;
      case 'userwellness':
        navigate('/AddRapports');
        break;
      default:
        navigate('/Home');
    }

  } catch (error) {
    console.error('❌ Erreur login:', error);

    if (error.response?.data?.errors) {
      error.response.data.errors.forEach(el => dispatch(handleerror(el.msg)));
    } else {
      dispatch(handleerror("Erreur de connexion"));
    }
  }
}

export const logout = () => {
  // Nettoyer le localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('userLocation'); // 🔥 Nettoyer aussi la localisation

  return {
    type: LOGOUT
  }
}

export const current = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}` // 🔥 Correction: "Authorization" pas "Authorised"
      }
    }

    const res = await axios.get('/api/auth/CurrentUser', config);

    dispatch({
      type: CURRENT,
      payload: res.data
    });

  } catch (error) {
    console.error('Erreur current user:', error);

    // Déconnexion automatique uniquement si le token est vraiment invalide (401)
    // Ne pas déconnecter en cas d'erreur réseau ou serveur temporaire
    if (error.response?.status === 401) {
      dispatch(logout());
    }

    if (error.response?.data?.errors) {
      error.response.data.errors.forEach(element => {
        dispatch(handleerror(element.msg));
      });
    }
  }
}

export const getAllusers = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/auth/AllUser');

    dispatch({
      type: GETALLUSERS,
      payload: res.data.AllUser
    });

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de chargement des utilisateurs"));
  }
}

export const getOneUser = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/auth/OneUser/${id}`);

    dispatch({
      type: GETONEUSER,
      payload: res.data.OneUser
    });

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de chargement de l'utilisateur"));
  }
}

export const updateUser = (id, cordUser, navigate) => async (dispatch) => {
  try {
    await axios.put(`/api/auth/UpdateUser/${id}`, cordUser);

    dispatch(getAllusers());
    navigate('/AllUser');

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de mise à jour de l'utilisateur"));
  }
}

export const deleteUser = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/auth/DeleteUser/${id}`);
    dispatch(getAllusers());

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de suppression de l'utilisateur"));
  }
}

export const updateProfil = (id, cordUser, navigate) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/auth/UpdateUser/${id}`, cordUser);

    // Mettre à jour le token et l'utilisateur si le backend retourne de nouvelles données
    if (res.data.token) {
      localStorage.setItem('token', res.data.token);
    }
    if (res.data.user) {
      localStorage.setItem('user', JSON.stringify(res.data.user));
    }

    dispatch(current()); // Met à jour le state utilisateur
    navigate('/Profil');

  } catch (error) {
    console.error('Erreur mise à jour profil:', error);
    dispatch(handleerror("Erreur de mise à jour du profil"));
  }
};